export default {
  list: [],
  listMeta: {},
  listLoading: false,
  createLoading: false,
  deleteLoading: false,
};
